import React, { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  TextField,
  Box,
  Button,
  Typography
} from "@material-ui/core";
import {
  SocialPlatforms,
  socialPlatformTitles
} from "../../../../constants/SocialPlatforms";

export interface SuggestFormInterface {
  submit: (show: {
    platform: SocialPlatforms;
    user: string;
    time: Date;
  }) => void;
  cancel: () => void;
}

const SuggestForm: React.FC<SuggestFormInterface> = ({ submit, cancel }) => {
  const [platform, setPlatform] = useState<SocialPlatforms>();
  const [username, setUsername] = useState<string>();
  const [date, setDate] = useState<string>();
  const [time, setTime] = useState<string>();

  const onSubmit = () => {
    let enteredDate;

    if (date && time) {
      enteredDate = new Date(`${date} ${time}`);
    }

    if (!platform) {
      alert("Select a Platform");
    } else if (!username) {
      alert("Enter a Username");
    } else if (!enteredDate) {
      alert("Enter a valid Date and Time");
    } else {
      submit({ platform, user: username, time: enteredDate });
    }
  };

  return (
    <Box paddingY={2} paddingX={3}>
      <Typography
        variant="h2"
        style={{ fontSize: "18px", marginBottom: "16px" }}
      >
        Add Live Stream to the Listings
      </Typography>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <div>
          <Typography variant="h3" component="h4" style={{ fontSize: "16px" }}>
            Platform
          </Typography>
          {Object.keys(socialPlatformTitles).map(k => {
            const key = k as SocialPlatforms;
            return (
              <FormControlLabel
                control={
                  <Checkbox
                    name={key}
                    checked={key === platform}
                    onChange={() => setPlatform(key)}
                  />
                }
                label={socialPlatformTitles[key]}
              />
            );
          })}
        </div>
        <div style={{ flex: 1, marginLeft: "16px" }}>
          <Typography variant="h3" component="h4" style={{ fontSize: "16px" }}>
            Username
          </Typography>
          <TextField onChange={e => setUsername(e.target.value)} fullWidth />
        </div>
        <div style={{ flex: 1, marginLeft: "16px" }}>
          <Typography variant="h3" component="h4" style={{ fontSize: "16px" }}>
            When
          </Typography>
          <Box display="flex">
            <TextField
              onChange={e => setDate(e.target.value)}
              defaultValue={date}
              type="date"
              fullWidth
            />
            <TextField
              onChange={e => setTime(e.target.value)}
              defaultValue={time}
              type="time"
              fullWidth
            />
          </Box>
        </div>
        <Box display="flex" marginLeft={2}>
          <Button
            variant="outlined"
            onClick={onSubmit}
            color="primary"
            style={{ marginRight: "8px" }}
          >
            Submit
          </Button>
          <Button onClick={cancel}>Cancel</Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SuggestForm;
